import React from "react";
import PropTypes from "prop-types";

import { Message } from "semantic-ui-react";

import "./ProfileInfoStep.css";

import { useProfileInfoStepForm } from "./hooks/useProfileInfoStepForm";
import { Button, Form, Header } from "./components";

export function ProfileInfoStep({ user, onUpdate }) {
  const { formProps, onSubmit, loading, errorMessage } =
    useProfileInfoStepForm(user);

  return (
    <div data-test="profile-container" className="profile-container">
      <Header as="h2" textAlign="center">
        <Header.Content>
          Create your Hubly Profile
          <Header.Subheader>
            You can always change this later in the Settings of your Hub
          </Header.Subheader>
        </Header.Content>
      </Header>

      <Message negative hidden={!errorMessage}>
        <Message.Header>Error</Message.Header>
        <p>{errorMessage}</p>
      </Message>

      <Form
        {...formProps}
        onSubmit={(data) => {
          onUpdate(data);
          onSubmit(data);
        }}
      >
        <Form.Input
          label="First Name"
          name="firstName"
          disabled={loading}
          required
          fluid
          placeholder="Enter First Name"
        />

        <Form.Input
          label="Last Name"
          name="lastName"
          disabled={loading}
          required
          fluid
          placeholder="Enter Last Name"
        />

        <Form.Input
          label="Phone Number"
          name="phoneNumber"
          disabled={loading}
          required
          fluid
          placeholder="Enter Phone Number"
        />

        <Form.Input
          label="Firm Name"
          name="firmName"
          disabled={loading}
          required
          fluid
          placeholder="Enter Firm Name"
        />

        <Button
          className="action-button"
          loading={loading}
          disabled={loading}
          content="Continue"
        />
      </Form>
    </div>
  );
}
ProfileInfoStep.propTypes = {
  user: PropTypes.object,
  onUpdate: PropTypes.func,
};

ProfileInfoStep.defaultProps = {
  user: {},
  onUpdate: () => {},
};

export default ProfileInfoStep;
